var map = {
	"./apple-laurel-da-DK.svg": 69732,
	"./apple-laurel-de-DE.svg": 32646,
	"./apple-laurel-en-GB.svg": 63452,
	"./apple-laurel-en-US.svg": 83111,
	"./apple-laurel-es-ES.svg": 71984,
	"./apple-laurel-es-MX.svg": 41379,
	"./apple-laurel-fr-FR.svg": 88296,
	"./apple-laurel-it-IT.svg": 68926,
	"./apple-laurel-nb-NO.svg": 31685,
	"./apple-laurel-nl-NL.svg": 91748,
	"./apple-laurel-pl-PL.svg": 56156,
	"./apple-laurel-pt-BR.svg": 45904,
	"./apple-laurel-pt-PT.svg": 9788,
	"./apple-laurel-sv-SE.svg": 93005
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87083;